module.exports = __webpack_public_path__ + "img/live_title.2451326e.png";